import { useEffect, useMemo } from "react";
import { CardContent, Typography, Box } from "@mui/material";
import { MixpanelWrapper } from "../MixPanelWrapper";
import { ProductLimitTable } from "../ProductLimitTable";
import { RatingRegionsTable } from "../RatingRegionsTable";
import { CommissionSlider } from "../CommissionSlider";
import { AddressFields } from "../AddressFields";
// import { useQuoteContext } from "../../shared/contexts/QuoteContext";
import { QuoteGroupResponse } from "../../shared/types/quotes";
import CreateQuoteCardHeader from "../CreateQuoteCardHeader";
import CreateQuoteSectionTitle from "../CreateQuoteSectionTitle";
import FeeBreakdownTable from "../FeeBreakdownTable";
import DownloadQuotesTable from "../DownloadQuotesTable";
import { useQuoteContext } from "../../shared/contexts/QuoteContext";

/**
 * Component for binding insurance coverage.
 *
 * @param {Object} props - The component's props.
 * @param {Object} props.options - Formik form options.
 * @param {Array} props.products - An array of product data.
 * @param {Array} props.packages - An array of package data.
 * @param {Array} props.displayProductRows - An array of product rows to display.
 * @param {Function} props.removeProduct - A function to remove a product.
 * @param {Function} props.removePackage - A function to remove a package.
 * @param {Function} props.checkBoxHandler - A function to handle checkbox changes.
 * @param {Function} props.organizeProductRowData - A function to organize product row data.
 *
 * @returns {JSX.Element} The JSX element for binding insurance coverage.
 */
const CoverageSummary = (props: any) => {

	useEffect(() => {
		MixpanelWrapper.track("Create Quote - Bind Cover");
	}, []);

	return (
		<>
			<CreateQuoteCardHeader title={"Coverage summary"} />
			<CardContent>
				{/* <Box pb="2em">
					<CreateQuoteSectionTitle
						title={"What is the insured's address"}
						tooltip={"This is the main/head office of the insured."}
						variant="cardContentHeader"
					/>
					<Box py="1em">
						<AddressFields
							options={props.options}
						/>
					</Box>
				</Box> */}
				<Box pb="2em">
					<Box pb="1em">
						<Typography variant="cardContentHeader">Customise your quote</Typography>
					</Box>

					<CommissionSlider />
				</Box>

				<Box pb="2em">
					<ProductLimitTable
                        options={props.options}
						removeProduct={props.removeProduct}
						removePackage={props.removePackage}
						checkBoxHandler={props.checkBoxHandler}
					/>
				</Box>

				<Box pb="2em">
					<CreateQuoteSectionTitle title={"Fee Breakdown"} />
					<FeeBreakdownTable />
				</Box>

				<Box pb="2em">
					<CreateQuoteSectionTitle title={"Quote Documents"} />
					<DownloadQuotesTable referralQuestions={props.referralQuestions} />
				</Box>
			</CardContent>
		</>
	);
};

export default CoverageSummary;
